import { func } from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { updateTrendBoardById } from '@services/trendResearch';

const MoodBoardSections = ({ sections, callBack }) => {
	const dispatch = useDispatch();
	const [sectionList, setSectionList] = useState([]);

	useEffect(() => {
		setSectionList(sections);
	}, [sections]);

	const handleChange = (e, id) => {
		const { name, value } = e.target;
		const tmpList = [...sectionList];
		const selectedIdx = tmpList.findIndex((item) => item.id === id);

		tmpList[selectedIdx][name] = value;
		setSectionList(tmpList);

		if (name === 'description' && e.target.tagName === 'TEXTAREA') {
			adjustTextareaHeight(e.target);
		}
	};

	const handleOnBlur = async (e, id) => {
		try {
			const { name, value } = e.target;
			let fieldName = name === 'title' ? 'sectionTitle' : 'sectionDescription';
			dispatch(openLoader());
			await updateTrendBoardById(`section/${id}`, { [fieldName]: value });
			callBack();
			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};

	const adjustTextareaHeight = (textarea) => {
		if (textarea) {
			textarea.style.height = 'auto';
			textarea.style.height = `${textarea.scrollHeight}px`;
		}
	};

	return (
		<>
			{sectionList.map((item, idx) => (
				<div className="single-textarea" key={`mood_board_section_${idx}`}>
					<div className="form-group">
						<input
							type="text"
							value={item.title}
							name="title"
							placeholder="Title"
							onChange={(e) => handleChange(e, item.id)}
							onBlur={(e) => handleOnBlur(e, item.id)}
						/>
					</div>
					<div className="form-group">
						<textarea
							placeholder="Description"
							name="description"
							value={item.description}
							onChange={(e) => handleChange(e, item.id)}
							onBlur={(e) => handleOnBlur(e, item.id)}
							rows={1}
							style={{ resize: 'none', overflow: 'hidden' }}
							ref={adjustTextareaHeight}
						/>
					</div>
				</div>
			))}
		</>
	);
};

MoodBoardSections.propTypes = {
	callBack: func.isRequired
};

export default MoodBoardSections;
